<template>
  <div class="c-table" ref="designkpitable">
    <el-table class="common-el-table-styles" :data="data" :height="height" border stripe>
      <el-table-column
        v-for="(col, id) in columns"
        :key="id"
        :prop="col.key"
        :label="col.title"
        :show-overflow-tooltip="col.overflow"
        :min-width="col.width"
        :align="col.align"
      >
        <template slot-scope="scope">
          <span v-if="col.key === 'checkTime'">{{ scope.row[col.key] }}</span>
          <div v-else-if="col.key === 'control'">
            <el-button type="text" size="small" @click="$emit('on-edit', scope.row)">修改</el-button>
            <Poptip confirm transfer title="您确认删除该奖金基准值吗？" @on-ok="$emit('on-del', scope.row)">
              <el-button type="text" size="small">&emsp;删除</el-button>
            </Poptip>
          </div>
          <span v-else-if="col.key === 'type'">{{ scope.row[col.key] | toImageType }}</span>
          <span v-else-if="col.key === 'threshold'">{{ scope.row[col.key] | toThousands }}</span>
          <span v-else-if="col.key === 'updateTime'">{{ scope.row[col.key] | datetimeToSec }}</span>
          <span v-else-if="col.key === 'createTime'">{{ scope.row[col.key] | datetimeToSec }}</span>
          <span v-else>{{ scope.row[col.key] }}</span>
        </template>
      </el-table-column>
    </el-table>
  </div>
</template>
<script>
export default {
  name: 'designKpiTable',
  props: {
    data: {
      type: Array,
      default() {
        return []
      }
    },
    columns: {
      type: Array
    },
    height: {
      type: Number
    }
  },
  filters: {
    toImageType(cellValue) {
      if (cellValue === 1) return '图片'
      else if (cellValue === 2) return '视频'
    }
  }
}
</script>
